interface HasOwn {
  <T extends object, Key extends string>(
    obj: T,
    key: string extends Key ? never : Key,
  ): obj is T & Record<Key, unknown>;

  <T extends object, Key extends symbol>(
    obj: T,
    key: symbol extends Key ? never : Key,
  ): obj is T & Record<Key, unknown>;

  <T extends object, Key extends number>(
    obj: T,
    key: number extends Key ? never : Key,
  ): obj is T & Record<Key, unknown>;

  <T extends object, Key extends PropertyKey>(
    obj: T,
    key: Key,
  ): key is Extract<keyof T, Key>;
}

const hasOwn: HasOwn =
  (Object.hasOwn as HasOwn) ??
  Object.prototype.hasOwnProperty.call.bind(Object.prototype.hasOwnProperty);

export default hasOwn;
